<div class="wallet-container">

  <div class="back-and-payment-method">
    <div
      class="selected-payment-method flex justify-center sm:justify-center items-center round-border-normal mt-4 sm:mr-0 sm:mt-8">
      <span
        class="wpx-200 hpx-125 sm:wpx-250 sm:hpx-150 background-cover rounded-md bg-cover flex justify-center items-center">
        <img [src]="paymentMethodImg" class="w-full">
      </span>
    </div>
  </div>

  <form [action]="controllerUrl" class="cdk-visually-hidden" hidden id="switchpay-form" method="post">
    <input [value]="redirectUrl" hidden id="redirectUrl" name="url">
  </form>

  <div [ngClass]="loading ? 'sm:pt-6' : 'sm:pt-0'"
       class="flex flex-wrap bg-gray-300 sm:pb-6 sm:ml-12 ml-4 sm:mr-12 mr-4 mb-16 mt-16 p-2" style="border-radius: 12px;">
    <div class="container mat-typography" style="margin-bottom: 25px;">
      <p class="mat-typography text-center text-lg text-gray-800 mb-0">Please wait while you are redirected to
        Switchpay™</p>
    </div>
    <div class="container">
      <mat-spinner
        *ngIf="loading"
        [color]="color"
        [diameter]="diameter"
        class="loading-spinner"
      >
      </mat-spinner>
    </div>
    <div class="container mat-typography" style="margin-top: 25px;">
      <p class="mat-typography text-lg text-gray-800 mb-0">Redirecting in: </p>
      <countdown [config]="config" class="text-lg" style="margin-left: 5px;"></countdown>
    </div>
    <router-outlet></router-outlet>
  </div>

  <div
    class="bottom-container w-full flex flex-row items-end pl-0 pr-0 sm:pl-2 sm:pr-2 pb-0 justify-between absolute bottom-0 mat-typography">
    <p class="text-md sm:text-lg ml-2 text-gray-800 mb-2">This is a secure transaction</p>
    <img *ngIf="!hidePgLogo" class="sm:h-14 h-12 mr-2 mb-0 sm:mr-2 sm:mb-1"
         src="assets/icons/Icons/Group.png">
  </div>

</div>
